import { ComponentType } from 'react';
import { ClearIndicatorProps, components, GroupBase } from 'react-select';
import { Option } from '@connect-x-app/shared-types';
import { COLORS } from '@connect-x-app/shared-ui';
import { INPUT_TEST_IDS } from '@connect-x-app/web-test-ids';

import { Icon } from '../../icon';

export const ClearIndicator: ComponentType<ClearIndicatorProps<Option, boolean, GroupBase<Option>>> | undefined = ({
  ...props
}: ClearIndicatorProps<Option, boolean>) => (
  <components.ClearIndicator {...props}>
    {props.children}
    <Icon colorName={COLORS.zulu.$08} name="close" testId={INPUT_TEST_IDS.clear} />
  </components.ClearIndicator>
);
